/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "dymensionxyz.dymension.delayedack";

export enum RollappPacket_Type {
  ON_RECV = 0,
  ON_ACK = 1,
  ON_TIMEOUT = 2,
  UNDEFINED = -1,
  UNRECOGNIZED = -1,
}

export function rollappPacket_TypeFromJSON(object: any): RollappPacket_Type {
  switch (object) {
    case 0:
    case "ON_RECV":
      return RollappPacket_Type.ON_RECV;
    case 1:
    case "ON_ACK":
      return RollappPacket_Type.ON_ACK;
    case 2:
    case "ON_TIMEOUT":
      return RollappPacket_Type.ON_TIMEOUT;
    case -1:
    case "UNDEFINED":
      return RollappPacket_Type.UNDEFINED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RollappPacket_Type.UNRECOGNIZED;
  }
}

export function rollappPacket_TypeToJSON(object: RollappPacket_Type): string {
  switch (object) {
    case RollappPacket_Type.ON_RECV:
      return "ON_RECV";
    case RollappPacket_Type.ON_ACK:
      return "ON_ACK";
    case RollappPacket_Type.ON_TIMEOUT:
      return "ON_TIMEOUT";
    case RollappPacket_Type.UNDEFINED:
      return "UNDEFINED";
    case RollappPacket_Type.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** MsgFinalizePacket finalizes a single packet. */
export interface MsgFinalizePacket {
  /** Sender is the signer of the message. */
  sender: string;
  /** RollappID is the ID of the rollapp. */
  rollappId: string;
  /** PacketProofHeight is a height at which the proof was retrieved. */
  packetProofHeight: number;
  /** PacketType is a type of the packet. Eg, RECV, ACK, TIMEOUT. */
  packetType: RollappPacket_Type;
  /** PacketSrcChannel identifies the channel end on the sending chain. */
  packetSrcChannel: string;
  /** PacketSequence is a sequence number of the packet. */
  packetSequence: number;
}

export interface MsgFinalizePacketResponse {
}

/** MsgFinalizePacketByPacketKey finalizes a single packet by the packet key. */
export interface MsgFinalizePacketByPacketKey {
  /** Sender is the signer of the message. */
  sender: string;
  /** PacketKey is a key of the packet. */
  packetKey: string;
}

export interface MsgFinalizePacketByPacketKeyResponse {
}

function createBaseMsgFinalizePacket(): MsgFinalizePacket {
  return { sender: "", rollappId: "", packetProofHeight: 0, packetType: 0, packetSrcChannel: "", packetSequence: 0 };
}

export const MsgFinalizePacket = {
  encode(message: MsgFinalizePacket, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }
    if (message.rollappId !== "") {
      writer.uint32(18).string(message.rollappId);
    }
    if (message.packetProofHeight !== 0) {
      writer.uint32(24).uint64(message.packetProofHeight);
    }
    if (message.packetType !== 0) {
      writer.uint32(32).int32(message.packetType);
    }
    if (message.packetSrcChannel !== "") {
      writer.uint32(42).string(message.packetSrcChannel);
    }
    if (message.packetSequence !== 0) {
      writer.uint32(48).uint64(message.packetSequence);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFinalizePacket {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFinalizePacket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;
        case 2:
          message.rollappId = reader.string();
          break;
        case 3:
          message.packetProofHeight = longToNumber(reader.uint64() as Long);
          break;
        case 4:
          message.packetType = reader.int32() as any;
          break;
        case 5:
          message.packetSrcChannel = reader.string();
          break;
        case 6:
          message.packetSequence = longToNumber(reader.uint64() as Long);
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgFinalizePacket {
    return {
      sender: isSet(object.sender) ? String(object.sender) : "",
      rollappId: isSet(object.rollappId) ? String(object.rollappId) : "",
      packetProofHeight: isSet(object.packetProofHeight) ? Number(object.packetProofHeight) : 0,
      packetType: isSet(object.packetType) ? rollappPacket_TypeFromJSON(object.packetType) : 0,
      packetSrcChannel: isSet(object.packetSrcChannel) ? String(object.packetSrcChannel) : "",
      packetSequence: isSet(object.packetSequence) ? Number(object.packetSequence) : 0,
    };
  },

  toJSON(message: MsgFinalizePacket): unknown {
    const obj: any = {};
    message.sender !== undefined && (obj.sender = message.sender);
    message.rollappId !== undefined && (obj.rollappId = message.rollappId);
    message.packetProofHeight !== undefined && (obj.packetProofHeight = Math.round(message.packetProofHeight));
    message.packetType !== undefined && (obj.packetType = rollappPacket_TypeToJSON(message.packetType));
    message.packetSrcChannel !== undefined && (obj.packetSrcChannel = message.packetSrcChannel);
    message.packetSequence !== undefined && (obj.packetSequence = Math.round(message.packetSequence));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFinalizePacket>, I>>(object: I): MsgFinalizePacket {
    const message = createBaseMsgFinalizePacket();
    message.sender = object.sender ?? "";
    message.rollappId = object.rollappId ?? "";
    message.packetProofHeight = object.packetProofHeight ?? 0;
    message.packetType = object.packetType ?? 0;
    message.packetSrcChannel = object.packetSrcChannel ?? "";
    message.packetSequence = object.packetSequence ?? 0;
    return message;
  },
};

function createBaseMsgFinalizePacketResponse(): MsgFinalizePacketResponse {
  return {};
}

export const MsgFinalizePacketResponse = {
  encode(_: MsgFinalizePacketResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFinalizePacketResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFinalizePacketResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgFinalizePacketResponse {
    return {};
  },

  toJSON(_: MsgFinalizePacketResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFinalizePacketResponse>, I>>(_: I): MsgFinalizePacketResponse {
    const message = createBaseMsgFinalizePacketResponse();
    return message;
  },
};

function createBaseMsgFinalizePacketByPacketKey(): MsgFinalizePacketByPacketKey {
  return { sender: "", packetKey: "" };
}

export const MsgFinalizePacketByPacketKey = {
  encode(message: MsgFinalizePacketByPacketKey, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sender !== "") {
      writer.uint32(10).string(message.sender);
    }
    if (message.packetKey !== "") {
      writer.uint32(18).string(message.packetKey);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFinalizePacketByPacketKey {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFinalizePacketByPacketKey();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.sender = reader.string();
          break;
        case 2:
          message.packetKey = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): MsgFinalizePacketByPacketKey {
    return {
      sender: isSet(object.sender) ? String(object.sender) : "",
      packetKey: isSet(object.packetKey) ? String(object.packetKey) : "",
    };
  },

  toJSON(message: MsgFinalizePacketByPacketKey): unknown {
    const obj: any = {};
    message.sender !== undefined && (obj.sender = message.sender);
    message.packetKey !== undefined && (obj.packetKey = message.packetKey);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFinalizePacketByPacketKey>, I>>(object: I): MsgFinalizePacketByPacketKey {
    const message = createBaseMsgFinalizePacketByPacketKey();
    message.sender = object.sender ?? "";
    message.packetKey = object.packetKey ?? "";
    return message;
  },
};

function createBaseMsgFinalizePacketByPacketKeyResponse(): MsgFinalizePacketByPacketKeyResponse {
  return {};
}

export const MsgFinalizePacketByPacketKeyResponse = {
  encode(_: MsgFinalizePacketByPacketKeyResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MsgFinalizePacketByPacketKeyResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMsgFinalizePacketByPacketKeyResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(_: any): MsgFinalizePacketByPacketKeyResponse {
    return {};
  },

  toJSON(_: MsgFinalizePacketByPacketKeyResponse): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<MsgFinalizePacketByPacketKeyResponse>, I>>(
    _: I,
  ): MsgFinalizePacketByPacketKeyResponse {
    const message = createBaseMsgFinalizePacketByPacketKeyResponse();
    return message;
  },
};

/** Msg defines the Msg service. */
export interface Msg {
  /** FinalizePacket finalizes a singe packet. */
  FinalizePacket(request: MsgFinalizePacket): Promise<MsgFinalizePacketResponse>;
  FinalizePacketByPacketKey(request: MsgFinalizePacketByPacketKey): Promise<MsgFinalizePacketByPacketKeyResponse>;
}

export class MsgClientImpl implements Msg {
  private readonly rpc: Rpc;
  constructor(rpc: Rpc) {
    this.rpc = rpc;
    this.FinalizePacket = this.FinalizePacket.bind(this);
    this.FinalizePacketByPacketKey = this.FinalizePacketByPacketKey.bind(this);
  }
  FinalizePacket(request: MsgFinalizePacket): Promise<MsgFinalizePacketResponse> {
    const data = MsgFinalizePacket.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.delayedack.Msg", "FinalizePacket", data);
    return promise.then((data) => MsgFinalizePacketResponse.decode(new _m0.Reader(data)));
  }

  FinalizePacketByPacketKey(request: MsgFinalizePacketByPacketKey): Promise<MsgFinalizePacketByPacketKeyResponse> {
    const data = MsgFinalizePacketByPacketKey.encode(request).finish();
    const promise = this.rpc.request("dymensionxyz.dymension.delayedack.Msg", "FinalizePacketByPacketKey", data);
    return promise.then((data) => MsgFinalizePacketByPacketKeyResponse.decode(new _m0.Reader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var globalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
    : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
      : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
